/**
 * 门户 / 管理端登录准入（与 backend user_type、auth _roles_for_user 对齐）
 * userType: 0 学生 1 教师 2 超级管理 3 平台管理 4 高校管理
 */

/** 是否可使用用户门户（全部业务账号均可） */
export function canUsePortal(user, roles) {
  if (!user) return false;
  if (user.status != null && String(user.status) !== "0") {
    return false;
  }
  const ut = normalizeUserType(user, roles);
  return [0, 1, 2, 3, 4].includes(ut);
}

/** 是否可进入管理端 */
export function canUseAdmin(roles) {
  const r = roles || [];
  return (
    r.includes("admin") ||
    r.includes("manager") ||
    r.includes("super_admin") ||
    r.includes("platform_admin") ||
    r.includes("college_admin") ||
    r.includes("teacher")
  );
}

/** 个人中心（学员/教师专属菜单与数据） */
export function isPortalStudentOrTeacher(user) {
  if (!user) return false;
  return [0, 1].includes(Number(user.userType));
}

/** 平台运营账号：可预览全部课程 */
export function isPlatformOperator(user, roles) {
  if (user && [2, 3].includes(Number(user.userType))) {
    return true;
  }
  const r = roles || [];
  return (
    r.includes("super_admin") ||
    r.includes("platform_admin") ||
    r.includes("admin") ||
    r.includes("manager")
  );
}

export function portalRoleLabel(userType) {
  const ut = Number(userType);
  if (ut === 1) return "教师";
  if (ut === 2) return "超级管理员";
  if (ut === 3) return "平台管理员";
  if (ut === 4) return "高校管理员";
  return "学员";
}

function normalizeUserType(user, roles) {
  const ut = Number(user.userType);
  if (!Number.isNaN(ut)) return ut;
  const r = roles || [];
  if (r.includes("teacher")) return 1;
  if (r.includes("super_admin") || r.includes("admin") || r.includes("manager")) return 2;
  if (r.includes("platform_admin")) return 3;
  if (r.includes("college_admin")) return 4;
  if (r.includes("student")) return 0;
  return -1;
}

/** 是否可直接学习（免选课/免付费拦截） */
export function canFaceLearnCourse(detail, user, roles) {
  if (isPlatformOperator(user, roles)) {
    return true;
  }
  return !(detail && detail.needPay);
}
